import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-57e405a6"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-share" }, null, -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-logo-circle" }, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-move-folder" }, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-copy-content" }, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-trash" }, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-info" }, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-close" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_bottom_pop_up_item = _resolveComponent("bottom-pop-up-item")!
  const _component_app_bottom_pop_up = _resolveComponent("app-bottom-pop-up")!

  return (_openBlock(), _createBlock(_component_app_bottom_pop_up, {
    onHide: _ctx.hidePopUp,
    "hide-bottom-decoration": "",
    "hide-top-decoration": "",
    class: "case-settings"
  }, {
    title: _withCtx(() => [
      _createTextVNode(_toDisplayString(_ctx.$localize('case.settings.popup.title')), 1)
    ]),
    body: _withCtx(() => [
      _createVNode(_component_bottom_pop_up_item, {
        onClick: _cache[0] || (_cache[0] = ($event: any) => {_ctx.$emit('onShare');})
      }, {
        icon: _withCtx(() => [
          _hoisted_1
        ]),
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$localize('photo.view.share')) + " ", 1)
        ]),
        _: 1
      }),
      (!_ctx.isNetwork && _ctx.isMy)
        ? (_openBlock(), _createBlock(_component_bottom_pop_up_item, {
            key: 0,
            onClick: _ctx.editCase
          }, {
            icon: _withCtx(() => [
              _hoisted_2
            ]),
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$localize('case.settings.popup.rename.option')) + " ", 1)
            ]),
            _: 1
          }, 8, ["onClick"]))
        : _createCommentVNode("", true),
      (!_ctx.isNetwork && _ctx.isMy)
        ? (_openBlock(), _createBlock(_component_bottom_pop_up_item, {
            key: 1,
            onClick: _ctx.openMovePopUp
          }, {
            icon: _withCtx(() => [
              _hoisted_3
            ]),
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$localize('case.settings.popup.move.option')) + " ", 1)
            ]),
            _: 1
          }, 8, ["onClick"]))
        : _createCommentVNode("", true),
      (_ctx.allowSave)
        ? (_openBlock(), _createBlock(_component_bottom_pop_up_item, {
            key: 2,
            onClick: _ctx.saveCaseAsCopy
          }, {
            icon: _withCtx(() => [
              _hoisted_4
            ]),
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$localize('case.settings.popup.copy.option')) + " ", 1)
            ]),
            _: 1
          }, 8, ["onClick"]))
        : _createCommentVNode("", true),
      (!_ctx.isNetwork && _ctx.isMy)
        ? (_openBlock(), _createBlock(_component_bottom_pop_up_item, {
            key: 3,
            onClick: _ctx.deleteCase
          }, {
            icon: _withCtx(() => [
              _hoisted_5
            ]),
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$localize('case.settings.popup.delete.option')) + " ", 1)
            ]),
            _: 1
          }, 8, ["onClick"]))
        : _createCommentVNode("", true),
      (!_ctx.isNetwork && _ctx.isMy)
        ? (_openBlock(), _createBlock(_component_bottom_pop_up_item, {
            key: 4,
            onClick: _ctx.openInfoPopUp
          }, {
            icon: _withCtx(() => [
              _hoisted_6
            ]),
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$localize('case.settings.popup.info.option')) + " ", 1)
            ]),
            _: 1
          }, 8, ["onClick"]))
        : _createCommentVNode("", true),
      (_ctx.isNetwork && !_ctx.isMy)
        ? (_openBlock(), _createBlock(_component_bottom_pop_up_item, {
            key: 5,
            onClick: _ctx.removeSharing
          }, {
            icon: _withCtx(() => [
              _hoisted_7
            ]),
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$localize('case.settings.popup.remove.sharing')) + " ", 1)
            ]),
            _: 1
          }, 8, ["onClick"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["onHide"]))
}